import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';
import useUploadFile from '../../../../hooks/upload-file.hook';
import UploadImage from '../../../../shared/upload-image/upload-image';

function ProgramInfo(props) {
    const { register, formState: { errors }, setValue } = useFormContext();

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-layer-group text-primary me-2"></i>
                    Basics
                </h6>

                {/* Title and Subtitle Row */}
                <div className='row mb-3'>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Title
                            </Form.Label>
                            <Form.Control
                            maxLength={150}
                                {...register("title", {
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                                type="text" placeholder="Enter title" />
                            {errors?.title ? <FieldError message={errors?.title?.message} /> : ''}
                        </Form.Group>

                    </div>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Subtitle</Form.Label>
                            <Form.Control
                                {...register("subtitle")}
                                type="text" placeholder="Enter subtitle" />
                        </Form.Group>
                    </div>
                </div>

                {/* Description Row */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Description</Form.Label>
                            <Form.Control
                                {...register("program_description")}
                                as="textarea"
                                rows={5}
                                placeholder="Enter description"
                            />
                        </Form.Group>
                    </div>
                </div>

                {/* Banner Image and Location Row Start*/}
                <div className='row'>
                    <>
                        <UploadImage setImage={(imagePath) => {
                            setValue("banner_image_url", imagePath);
                        }} />
                        <input type='hidden' {...register("banner_image_url")} />
                    </>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Location</Form.Label>
                            <Form.Control
                                {...register("program_location")}
                                type="text"
                                placeholder="Enter location"

                            />
                        </Form.Group>
                    </div>
                </div>
                {/* Banner Image and Location Row End*/}
            </div>
        </>
    );
}

export default ProgramInfo;